import React from "react";
import { Container, Row, Col, ProgressBar } from "react-bootstrap";
import "./Skills.css";

const Skills = () => {
  return (
    <Container className="py-4 my-5">
      <p className="text-white text-center fw-bold fs-1">My Skills</p>
      <Row>
        <Col xs={12} sm={12} md={12} lg={7}>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              HTML
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`95%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              CSS
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`90%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              JavaScript
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`85%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              React JS
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`85%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              MongoDB
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`80%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              Node Js
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`78%`}
              className="color-bar"
            />
          </div>
          <div>
            <p className="text-white" style={{ display: "inline" }}>
              Express Js
            </p>
            <ProgressBar
              animated
              now={100}
              // label={`75%`}
              className="color-bar"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={5} className="ps-4">
          <div style={{ textAlign: "justify" }} className="mt-1">
            <h5 className="text-center fw-bold mt-1 pt-4 pb-2">
              My Creative Skills & Technologies
            </h5>
            <p>
              <span className="fw-bold">Expertise: </span>
              JavaScript, ES6, React.js, React Hook, HTML5, CSS3, Material-UI,
              Bootstrap-5, REST API
            </p>
            <p>
              <span className="fw-bold">Comfortable: </span>
              Firebase, Node.js, Redux, Redux Toolkit, MongoDB, Express.js,
              Tailwind, Ant Design
            </p>
            <p>
              <span className="fw-bold">Familiar: </span>
              Typescript, Networking, PC Troubleshooting
            </p>
            <p>
              <span className="fw-bold">Tools: </span>
              VS Code, Github, GitLab, Chrome Dev Tools, Heroku, Netlify,
              Terminal
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Skills;
